import { render, staticRenderFns } from "./QuarantineFilters.vue?vue&type=template&id=26489ade&scoped=true"
import script from "./QuarantineFilters.vue?vue&type=script&lang=js"
export * from "./QuarantineFilters.vue?vue&type=script&lang=js"
import style0 from "./QuarantineFilters.vue?vue&type=style&index=0&id=26489ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26489ade",
  null
  
)

export default component.exports